/* eslint eqeqeq: 'off' */ 
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

// GET Method for Buildings,( Retrieve all Buildings available in Tracer Ensemble Tenant Services)

export function GetBuildingsList() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_Buildings_List).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined && response.length > 0)
               dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_LIST_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }

 export function GetFamilyList(buildingID) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Family_Types+buildingID+url.get_Family_Types_Second_Part).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_FAMILY_LIST_SUCCESSFULL));
        }).catch(error => { 
            throw error;
        })
    }
}

export function GetObjectList(buildingID,FamilyID){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Buildings_List+ buildingID +"/family/" + FamilyID).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
               dispatch(actionToStoreSuccess(response,types.GET_EQUIPMENT_OBJECT_LIST_SUCCESSFULL));
        }).catch(error => { 
            throw error;
        })
    }
}



export function GetPointsList(buildingID) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Buildings_List+buildingID + "/points").then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_POINTS_LIST_SUCCESSFULL));
        }).catch(error => { 
            throw error;
        })
    }
}

export function GetEquipmentPointsList(buildingID,ObjectID) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Buildings_List+buildingID + "/equipment/"+ObjectID+"/points").then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
               dispatch(actionToStoreSuccess(response,types.GET_BUILDING_POINTS_LIST_SUCCESSFULL));
        }).catch(error => { 
            throw error;
        })
    }
}

export function GetUnitsList(dimensionID,UserDefinedID) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Tenant_Meters+ dimensionID + "/units/"+UserDefinedID).then(response => {
            dispatch(global_error_handling(response)); 
            dispatch(actionToStoreSuccess(response,types.GET_UNITS_LIST_SUCCESSFULL));
        }).catch(error => { 
            throw error;
        })
    }
}

export function GetDatalogMeterObjects(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Datalog_Meters).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_DATALOG_METERS_OBJECTS));
        }).catch(error => {
            throw error;
        })
    }
}

/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking it type and updates the state. */

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}



















